import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class HolidaysService {

  getHolidaysForYear(year: number): Date[] {
    const holidays: Date[] = [];

    // Fixed
    holidays.push(new Date(year, 0, 1));    // Neujahr 1.1.
    holidays.push(new Date(year, 4, 1));    // Tag der Arbeit 1.5.
    holidays.push(new Date(year, 9, 3));    // Tag der Deutschen Einheit 3.10.
    holidays.push(new Date(year, 11, 25));  // 1. Weihnachtstag in Deutschland 25.12.
    holidays.push(new Date(year, 11, 26));  // 2. Weihnachtstag in Deutschland 26.12.

    // Variable
    const easterDate = this.getEasterDate(year);

    holidays.push(new Date(easterDate.getTime() - 2 * 24 * 60 * 60 * 1000)); // Karfreitag
    holidays.push(new Date(easterDate.getTime() + 1 * 24 * 60 * 60 * 1000)); // Ostermontag
    holidays.push(new Date(easterDate.getTime() + 39 * 24 * 60 * 60 * 1000)); // Christi Himmelfahrt
    holidays.push(new Date(easterDate.getTime() + 50 * 24 * 60 * 60 * 1000)); // Pfingstmontag

    // Regional
    // holidays.push(new Date(easterDate.getTime() + 60 * 24 * 60 * 60 * 1000)); // Fronleichnam
    // holidays.push(new Date(year, 0, 6));    // Heilige Drei Könige 6.1.


    // TEST HOLIDAY
    // holidays.push(new Date(year, 2, 26));    // Test  26.3.
    return holidays;

  }

  // Easter calculation
  private getEasterDate(year: number): Date {
    const a = year % 19;
    const b = Math.floor(year / 100);
    const c = year % 100;
    const d = Math.floor(b / 4);
    const e = b % 4;
    const f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3);
    const h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4);
    const k = c % 4;
    const l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451);
    const month = Math.floor((h + l - 7 * m + 114) / 31);
    const day = ((h + l - 7 * m + 114) % 31) + 1;

    return new Date(year, month - 1, day);
  }

  isHoliday(date: Date): boolean {
    const holidays = this.getHolidaysForYear(date.getFullYear());

    return holidays.some(holiday =>
      holiday.getDate() === date.getDate() &&
      holiday.getMonth() === date.getMonth() &&
      holiday.getFullYear() === date.getFullYear()
    );
  }
}
